// extracted by mini-css-extract-plugin
export default {"list":"TooltipModal_list__UeOeZ","item":"TooltipModal_item__DYY-p","check":"TooltipModal_check__3rbMz"};